const formatFacultad = (value) => {
  const facultades = {
    facultad_de_ciencias_exactas_y_naturales: "Facultad de Ciencias Exactas y Naturales",
    facultad_de_ingenierias_y_arquitectura: "Facultad de Ingenierías y Arquitectura",
    facultad_de_ciencias_economicas_y_empresariales: "Facultad de Ciencias Económicas y Empresariales",
  };

  return facultades[value] || value;
};

const Facultad = ({ value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  const facultades = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .map(formatFacultad);

  return <>{facultades.join(" / ")}</>;
};

export default Facultad;